import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute, { ControlRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { Database } from "@phosphor-icons/react";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Team from "@/pages/Team";
import Dashboard from "@/pages/Dashboard";
import Connections from "@/pages/Connections";import Projects from "@/pages/Projects";
import ProjectWizard from "@/pages/ProjectWizard";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import AuditLogs from "@/pages/AuditLogs";
import Help from "@/pages/Help";
import Settings from "@/pages/Settings";
import RecordsExplorer from "@/pages/RecordsExplorer";
import Notifications from "@/pages/Notifications";
import ConnectorStudio from "@/pages/ConnectorStudio";
import ConnectorGuide from "@/pages/ConnectorGuide";
import Billing from "@/pages/Billing";
import ControlLogin from "@/pages/control/ControlLogin";
import ControlPortal from "@/pages/control/ControlPortal";

const P = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;
const C = ({ children }) => <ControlRoute>{children}</ControlRoute>;

function Root() {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen brand-ink flex items-center justify-center">
        <span className="w-10 h-10 rounded-xl bg-[#C2410C] flex items-center justify-center shadow-glow animate-pulse">
          <Database size={22} weight="fill" className="text-white" />
        </span>
      </div>
    );
  return user ? <Dashboard /> : <Landing />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/" element={<Root />} />
            <Route path="/team" element={<P><Team /></P>} />
            <Route path="/billing" element={<P><Billing /></P>} />
            <Route path="/control/login" element={<ControlLogin />} />
            <Route path="/control" element={<C><ControlPortal /></C>} />
            <Route path="/connections" element={<P><Connections /></P>} />
            <Route path="/connector-studio" element={<P><ConnectorStudio /></P>} />
            <Route path="/connector-guide" element={<P><ConnectorGuide /></P>} />
            <Route path="/projects" element={<P><Projects /></P>} />
            <Route path="/projects/new" element={<P><ProjectWizard /></P>} />
            <Route path="/projects/:pid/wizard" element={<P><ProjectWizard /></P>} />
            <Route path="/jobs" element={<P><Jobs /></P>} />
            <Route path="/jobs/:jid" element={<P><JobDetail /></P>} />
            <Route path="/records" element={<P><RecordsExplorer /></P>} />
            <Route path="/notifications" element={<P><Notifications /></P>} />
            <Route path="/audit" element={<P><AuditLogs /></P>} />
            <Route path="/help" element={<P><Help /></P>} />
            <Route path="/settings" element={<P><Settings /></P>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
